import { create } from "zustand"
import { persist } from "zustand/middleware"

// --- 로그인 전/후에 user를 nullable로 다루기 위한 타입 정의
interface User {
  id: string
  name: string
  thumbnailUrl?: string
}
interface UserState {
  user: User | null
  setUser: (user: User) => void
  resetUser: () => void
  isMineCheck: (id: string) => boolean
}

export const useUserStore = create<UserState>()(
  persist(
    (set, get) => ({
      user: null,
      folders: [],
      setUser: (user) => set({ user }),
      resetUser: () =>
        set({
          user: null,
        }),
      isMineCheck: (id) => {
        const { user } = get()
        return user !== null && user.id === id
      },
    }),
    {
      name: "my-user-store",
      partialize: (state) => ({
        user: state.user,
      }),
      storage: {
        getItem: (name) => {
          const item = sessionStorage.getItem(name)
          return item ? JSON.parse(item) : null
        },
        setItem: (name, value) => {
          sessionStorage.setItem(name, JSON.stringify(value))
        },
        removeItem: (name) => {
          sessionStorage.removeItem(name)
        },
      },
    },
  ),
)
